<div class="AC">
    <div class="AC__header">
        Please tell us about your <br/> company
    </div>
    <form class="AC__content" @submit.prevent="onSubmit">
        <input-container :dirtyForm="$v.$dirty || ifTenantExists">
            <div class="AC__label">Organization's legal name</div>
            <div class="AC__name">
                <text-field class="input-field"
                    :error="hasError('companyName') || ifTenantExists"
                    v-model="companyName"
                    @blur="checkIfTenantExists">
                </text-field>
                <progress-spinner class="AC__name-spinner" v-if="checking"></progress-spinner>
                <mom-icon class="AC__name-available" width="24" height="24"
                    svgIcon="checked-circle" v-else-if="checkDone && !ifTenantExists"></mom-icon>
                <mom-icon class="AC__name-unavailable" width="24" height="24"
                    svgIcon="cross-circle" v-else-if="checkDone && ifTenantExists"></mom-icon>
            </div>
            <mom-error v-if="!$v.companyName.required">Organization name is required.</mom-error>
            <mom-error v-else-if="ifTenantExists">Organization name already exists.</mom-error>
        </input-container>
        <input-container :dirtyForm="$v.$dirty">
            <div class="AC__label">Country</div>
            <auto-select class="input-field"
                :toText="toText"
                :options="countryOpts"
                v-model="selectedCountry"
                :error="hasError('selectedCountry')"
                @search="onSearch('countrySearch', $event)">
            </auto-select>
            <mom-error v-if="!$v.selectedCountry.required">Country is required.</mom-error>
        </input-container>
        <input-container :dirtyForm="$v.$dirty">
            <div class="AC__label">Industry</div>
            <auto-select class="input-field"
                :toText="toText"
                v-model="industry"
                :options="industryOpts"
                @search="onSearch('industrySearch', $event)"
                :error="hasError('industry')">
            </auto-select>
            <mom-error v-if="!$v.industry.required">Industry is required.</mom-error>
        </input-container>
        <input-container :dirtyForm="$v.$dirty">
            <div class="AC__label">Number of employees</div>
            <text-field type="number" class="input-field"
                :error="hasError('employeesCount')"
                v-model="employeesCount">
            </text-field>
            <mom-error v-if="!$v.employeesCount.required">Number of employees is required.</mom-error>
            <mom-error v-else-if="!$v.employeesCount.isValid">Please enter a valid number.</mom-error>
        </input-container>
        <!-- <input-container :dirtyForm="$v.$dirty">
            <div class="AC__label">What is your role</div>
            <auto-select class="input-field" :loading="false" :toText="toText"
                v-model="role" :options="roleOpts" :error="hasError('role')"
                @search="onSearch('roleSearch', $event)">
            </auto-select>
            <mom-error v-if="!$v.role.required">Role is required.</mom-error>
        </input-container> -->

        <div class="AC__proceed">
            <mom-button type="submit" variant="raised">Next</mom-button>
        </div>
    </form>
</div>